import React, { useEffect, useState } from "react";
import Axios from "axios";
import Navbar from "./Navbar";
import TextField from "@mui/material/TextField";
import { AiOutlineEye } from "react-icons/ai";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  listAll,
  list,
} from "firebase/storage";
import { storage } from "./firebase";
import { v4 } from "uuid";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { message, Spin } from "antd";
import { useHistory, useParams } from "react-router-dom";

const EditDoc = () => {
  const history = useHistory();
  const params = useParams();
  const [rowData, setRowData] = useState([]);

  useEffect(() => {
    document.title = "Edit Document";
  }, []);

  useEffect(() => {
    Axios.get("/api/templatedoc/readOneTemplate/" + params.id).then(
      (response) => {
        setTimeout(function () {
          setLoading(false);
        }, 100);
        setRowData(response.data.Templates);
      }
    );
  }, []);

  const [imageUpload, setImageUpload] = useState(null);
  const [imageUrls, setImageUrls] = useState([]);
  const [imgurl, setImgurl] = useState(rowData.Doc);
  const [fileNames, setFileNames] = useState([]);
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(rowData.Title);
  const [titleError, setTitleError] = useState(false);
  const [description, setDescription] = useState(rowData.Description);

  const setImageUploadFunction = (file) => {
    setImageUpload(file);
    const imageRef = ref(storage, `images/${file.name + v4()}`);
    uploadBytes(imageRef, file).then((snapshot) => {
      getDownloadURL(snapshot.ref).then((url) => {
        setImageUrls((prev) => [...prev, url]);
        setImgurl(url);
      });
    });
  };

  const [selectedImage, setSelectedImage] = useState();

  const imageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedImage(e.target.files[0]);
    }
  };

  const addToList = () => {
    setTitleError(false);

    if (title === "") {
      setTitleError(true);
      return;
    }

    // if (description === '') {
    //   message.error('Please Enter Description')
    //   return
    // }
    const config = { headers: { "Content-Type": "application/json" } };

    Axios.put(
      "/api/templatedoc/modifyTemplate/" + params.id,
      {
        Title: title,
        Description: description,
        Doc: imgurl,
      },
      config
    )
      .then(function (response) {
        message.success(" Updated successfully");
        setTimeout(function () {
          history.push("/doc-template");
        }, 1000);
      })
      .catch(function (error) {
        message.error(`${error.response.data.message}`);
      });
  };

  return (
    <>
      <Navbar title="Edit Image" show="false" />
      <div
        className="container-fluid pt-4"
        style={{ backgroundColor: "#F0F2FA" }}
      >
        <div
          className="card"
          style={{
            backgroundColor: "#F3F3F3",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              marginBottom: "20px",
              minWidth: "700px",
            }}
          >
            <TextField
              value={rowData.Title}
              className="lead-fields"
              style={{ width: "100%" }}
              required
              id="outlined-required"
              onChange={(e) => setTitle(e.target.value)}
              error={titleError}
            />
          </div>
          <div
            style={{
              minWidth: "700px",
              marginBottom: "20px",
            }}
          >
            <input
              style={{ maxWidth: "100%" }}
              type="file"
              required
              onChange={(event) => {
                setImageUploadFunction(event.target.files[0]);
                imageChange(event);
              }}
            />{" "}
          </div>
          <div
            style={{
              minWidth: "700px",
            }}
          >
            <TextareaAutosize
              defaultValue={rowData.Description}
              aria-label="minimum height"
              minRows={5}
              placeholder="Content"
              style={{ width: "100%", padding: "10px" }}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

          <div>
            <button onClick={addToList} className="btn btn-primary add-button">
              Edit Document Template
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditDoc;
